
const fields = [
  {
    type: 'bsx-label',
    label: 'ID',
    model: 'id',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '地區名稱',
    model: 'name',
    placeholder: '地區名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序權重",
    help: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
